module.exports={
    zh:{
         date:"日期",
         AffiliatedGarden: '所属园区',
         class:"所属班级",
         Gardenclass:"园所/班级",
         profession:"考勤对象",
         Garden:"园所",
         photo:'照片',
         name:'姓名',
         state:"状态",
         addActive:"添加活动",
         addDaily:'添加日报内容',
         upload:"上传",
         edit:"编辑",
         delete:'删除',
         hide:'隐藏',
         show:'显示',
         dailyContent:'日报内容',
         activity:'活动',
         student:"学生",
         time:"时间",
         describe:'描述',
         cancel:"取消",
         confirm:"确认",
         search:"搜索",
         reset:"重置",
         checkAll:"全选",
         review:'审核通过',
         notGo:'审核不通过',
         send:"发送选中日报",
         save:"保存",
         allStart:"全部开始",
         allEnd:"全部结束",
         toEat: "食量",
         multiple:"多选模式",
         single:"单选模式"
    },
    en:{
         date:"Date",   
         addActive:"Add Activity",
         AffiliatedGarden: 'School',
         class:"class", 
         hide:"hide",
         show:"show",
         Gardenclass:"School/Class",
         Garden:"Garden",
         profession:"profession",
         photo:'Phtoto',
         name:'Name',
         state:"Status",
         addDaily:'add daily content',
         upload:"upload",
         edit:"edit",
         delete:'Delete',
         dailyContent:"daily content",
         activity:'activity',
         student:"student",
         time:'time',
         describe:'describe',
         cancel:'cancel',
         confirm:"confirm",
         search:"search",
         reset:"reset",
         checkAll:"Select all",
         review:'Review and pass through',
         notGo:'Audit failed',
         send:"Send daily ",
         save:"save",
         allStart:"All Start",
         allEnd:"All End",
         toEat: "To Eat",
         multiple:"Multiple",
         single:"Single"
    } 
}



// WEBPACK FOOTER //
// ./src/components/i18n/lang/daily.js